var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrowDownLeft = function SvgArrowDownLeft(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05018 8.4645C6.05018 7.91222 6.49789 7.4645 7.05018 7.4645C7.60246 7.4645 8.05018 7.91222 8.05018 8.4645L8.05018 14.5356L16.2426 6.34318C16.6331 5.95266 17.2663 5.95266 17.6568 6.34318C18.0473 6.7337 18.0473 7.36687 17.6568 7.75739L9.46439 15.9498L15.5355 15.9498C16.0877 15.9498 16.5355 16.3975 16.5355 16.9498C16.5355 17.5021 16.0877 17.9498 15.5355 17.9498L7.05018 17.9498C6.49789 17.9498 6.05018 17.5021 6.05018 16.9498L6.05018 8.4645Z",
    fill: "black"
  })));
};
export { SvgArrowDownLeft as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down-left.c462a471.svg";